import React, { useMemo } from "react";
import { CffLogo } from "./CffLogo";
import { resolveTicketProviderBadge } from "./ticketProvider.tools";

/**
 * Props of {@link TicketProviderBadgeMark}.
 */
export interface TicketProviderBadgeMarkProps {

    /** Backend provider id (`purchase.provider`) driving the badge. */
    "provider": string;
}

/**
 * Provider identity mark shared by the two faces of a ticket card: the real
 * brand logo when one exists (`swiss_cff` → `CffLogo`), otherwise the colored
 * text pill resolved by {@link resolveTicketProviderBadge}.
 *
 * @param props - Component props.
 * @returns The provider badge.
 */
export const TicketProviderBadgeMark: React.FC<TicketProviderBadgeMarkProps> = ( { provider } ) => {
    const badge = useMemo( () => resolveTicketProviderBadge( provider ), [ provider ] );

    return (
        <span
            className="inline-flex shrink-0 items-center"
            data-testid="ticket-provider-badge"
        >
            {badge.kind === "logo" && badge.logo === "swiss_cff"
                ? <CffLogo />
                : (
                    <span
                        className="inline-flex items-center rounded-full px-2.5 py-1 text-[0.65rem] font-bold tracking-wide"
                        style={{
                            "background": badge.kind === "text" ? badge.background : "#475569",
                            "color":      badge.kind === "text" ? badge.color : "#FFFFFF",
                            ...badge.kind === "text" ? badge.style : {},
                        }}
                    >
                        {badge.label}
                    </span>
                )}
        </span>
    );
};
